import React from 'react';
import PropTypes from 'prop-types';
import TimePicker from 'eventbrite_design_system/timepicker/TimePicker';
import { STYLE_STATIC } from 'eventbrite_design_system/inputField/constants';
import ValidationFormField from 'eventbrite_design_system/validationFormField/ValidationFormField';
import EBPropTypes from 'js-utils/prop-types';

export default class ValidatedTime extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        name: PropTypes.string,
        label: EBPropTypes.translation,
        minTime: PropTypes.string,
    };

    render() {
        const { id, name, label, minTime } = this.props;

        return (
            <ValidationFormField
                id={id}
                name={name}
                label={label}
                minTime={minTime}
                v2={true}
            >
                <TimePicker style={STYLE_STATIC} isV2={true} />
            </ValidationFormField>
        );
    }
}
